import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { GET, POST, httpOk } from 'helpers/api'
import { loadChequeNotes } from 'helpers/chequeNotes'

function Index() {
	const { t } = useTranslation()

	const [noteSales, setNoteSales]           = useState('')
	const [noteProduction, setNoteProduction] = useState('')
	const [saving, setSaving]                 = useState(false)
	const [saveStatus, setSaveStatus]         = useState(null) // 'ok' | 'err'

	useEffect(() => {
		loadSettings()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	async function loadSettings() {
		const res = await GET('/cheque-note-settings', {}, { loader: true })
		if (httpOk(res)) {
			setNoteSales(res.data?.note_sales || '')
			setNoteProduction(res.data?.note_production || '')
		}
	}

	async function save(e) {
		e.preventDefault()
		setSaving(true)
		setSaveStatus(null)
		const res = await POST('/cheque-note-settings', {
			note_sales: noteSales,
			note_production: noteProduction,
		}, { loader: false })
		setSaving(false)
		if (httpOk(res)) {
			setSaveStatus('ok')
			loadChequeNotes() // localStorage cache'ni yangilaymiz -> darhol print uchun tayyor
			setTimeout(() => setSaveStatus(null), 3000)
		} else {
			setSaveStatus('err')
		}
	}

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('cheque_note_settings')}
				</h4>
			</div>

			<div className="row">
				<div className="col-md-9 col-lg-8">

					<div className="card border-0 mb-3" style={{ background: '#f8f9fa' }}>
						<div className="card-body py-3">
							<p className="mb-0 text-muted" style={{ fontSize: '13px' }}>
								<i className="uil uil-info-circle me-1 text-primary"></i>
								{t('cheque_note_page_hint')}
							</p>
						</div>
					</div>

					<form onSubmit={save} autoComplete="off">

						{/* Sotuv bo'limi matni */}
						<div className="card mb-3">
							<div className="card-body">
								<h6 className="fw-bold mb-1">
									<i className="uil uil-shopping-cart-alt me-1 text-primary"></i>
									{t('cheque_note_sales_label')}
								</h6>
								<div className="form-text mb-2">{t('cheque_note_sales_hint')}</div>
								<textarea
									className="form-control"
									rows="4"
									value={noteSales}
									onChange={e => setNoteSales(e.target.value)}
									style={{ fontSize: '14px', lineHeight: '1.6' }}
								/>
							</div>
						</div>

						{/* Ishlab chiqarish matni */}
						<div className="card mb-3">
							<div className="card-body">
								<h6 className="fw-bold mb-1">
									<i className="uil uil-constructor me-1 text-success"></i>
									{t('cheque_note_production_label')}
								</h6>
								<div className="form-text mb-2">{t('cheque_note_production_hint')}</div>
								<textarea
									className="form-control"
									rows="4"
									value={noteProduction}
									onChange={e => setNoteProduction(e.target.value)}
									style={{ fontSize: '14px', lineHeight: '1.6' }}
								/>
							</div>
						</div>

						{saveStatus === 'ok' && (
							<div className="alert alert-success py-2 mb-2" style={{ fontSize: '13px' }}>
								<i className="uil uil-check me-1"></i> {t('saved')}
							</div>
						)}
						{saveStatus === 'err' && (
							<div className="alert alert-danger py-2 mb-2" style={{ fontSize: '13px' }}>
								<i className="uil uil-exclamation-triangle me-1"></i> {t('error')}
							</div>
						)}

						<button type="submit" className="btn btn-primary" disabled={saving}>
							{saving
								? <><span className="spinner-border spinner-border-sm me-2"></span>{t('saving')}</>
								: t('save')}
						</button>
					</form>

				</div>
			</div>
		</>
	)
}

export default Index
